var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card-wrapper" },
    [
      _c("div", { staticClass: "card-top" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "card-heading" }, [
            _vm._m(0),
            _c("div", [
              _c("p", { staticClass: "card-title" }, [
                _vm._v("Thống kê album ảnh"),
              ]),
              _c("p", { staticClass: "card-subtitle" }, [
                _vm._v("Tình trạng đăng album ảnh ngày hiện tại"),
              ]),
              _c("div", { staticClass: "header-tags" }, [
                _c("span", { staticClass: "header-tag" }, [
                  _vm._v("Tổng số lớp: " + _vm._s(_vm.todayData.length)),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "summary-row" }, [
          _c(
            "div",
            {
              staticClass: "summary-card",
              staticStyle: { "--summary-accent": "#4f8dfd" },
            },
            [
              _c("span", { staticClass: "summary-label" }, [
                _vm._v("Tổng số lượng album"),
              ]),
              _c("strong", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.totalAlbums)),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "summary-card",
              staticStyle: { "--summary-accent": "#36cfc9" },
            },
            [
              _c("span", { staticClass: "summary-label" }, [
                _vm._v("Đã duyệt"),
              ]),
              _c("strong", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.totalApproved)),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "summary-card",
              staticStyle: { "--summary-accent": "#ff6b6b" },
            },
            [
              _c("span", { staticClass: "summary-label" }, [
                _vm._v("Chưa duyệt"),
              ]),
              _c("strong", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.totalUnapproved)),
              ]),
            ]
          ),
        ]),
      ]),
      _c(
        "el-row",
        { staticClass: "chart-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 8, lg: 8 } }, [
            _c("div", { staticClass: "chart-shell" }, [
              _c("div", { staticClass: "chart-caption" }, [
                _c("span", {
                  staticClass: "chart-caption__dot",
                  staticStyle: {
                    background: "#4f8dfd",
                    "box-shadow": "0 0 0 4px rgba(79, 141, 253, 0.14)",
                  },
                }),
                _c("span", [_vm._v("Tỷ lệ trạng thái")]),
              ]),
              _c(
                "div",
                { staticClass: "chartPie" },
                [
                  _vm.loaded
                    ? _c("ChartPie", {
                        attrs: {
                          chartData: _vm.pieChartData,
                          options: _vm.pieChartOptions,
                          checkLable: true,
                          height: 260,
                        },
                      })
                    : _vm._e(),
                  _vm.loaded
                    ? _c("div", { staticClass: "donut-center-text" }, [
                        _c("p", { staticClass: "center-value" }, [
                          _vm._v(_vm._s(_vm.totalAlbums)),
                        ]),
                        _c("p", { staticClass: "center-label" }, [
                          _vm._v("Album"),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 16, lg: 16 } }, [
            _c("div", { staticClass: "chart-shell" }, [
              _c("div", { staticClass: "chart-caption" }, [
                _c("span", {
                  staticClass: "chart-caption__dot",
                  staticStyle: {
                    background: "#36cfc9",
                    "box-shadow": "0 0 0 4px rgba(54, 207, 201, 0.14)",
                  },
                }),
                _c("span", [_vm._v("Theo lớp học")]),
              ]),
              _c("div", { staticClass: "chartBar-scroll-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "chartBar-inner",
                    style: { minWidth: _vm.chartMinWidth },
                  },
                  [
                    _vm.loaded
                      ? _c("ChartBar", {
                          attrs: {
                            chartData: _vm.barChartData,
                            options: _vm.barChartOptions,
                            height: 260,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "action-row",
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
            padding: "0 10px",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-weight": "700",
                color: "#22324d",
                "font-size": "16px",
              },
            },
            [_vm._v("\n      Danh sách chi tiết theo khoảng thời gian\n    ")]
          ),
          _c(
            "div",
            [
              _c("el-date-picker", {
                staticStyle: { "margin-right": "12px", width: "250px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": "Từ ngày",
                  "end-placeholder": "Đến ngày",
                  format: "dd/MM/yyyy",
                  "value-format": "yyyy-MM-dd",
                  size: "small",
                  clearable: false,
                },
                on: { change: _vm.fetchTableData },
                model: {
                  value: _vm.dateRange,
                  callback: function ($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    plain: "",
                    icon: "el-icon-s-data",
                    round: "",
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showTable = !_vm.showTable
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.showTable ? "Ẩn bảng" : "Hiện bảng") +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTable,
                expression: "showTable",
              },
            ],
            staticClass: "table-wrapper",
          },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  border: "",
                  stripe: "",
                  "header-cell-class-name": "custom-header",
                  "max-height": "400",
                  "show-summary": "",
                  "summary-method": _vm.getSummaries,
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: "STT",
                    width: "60",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "className",
                    label: "Tên",
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "total",
                    label: "Tổng số album",
                    align: "center",
                    "min-width": "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "approved",
                    label: "Đã duyệt",
                    align: "center",
                    "min-width": "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            { staticClass: "text-success font-weight-bold" },
                            [_vm._v(_vm._s(scope.row.approved))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "unapproved",
                    label: "Chưa duyệt",
                    align: "center",
                    "min-width": "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            { staticClass: "text-danger font-weight-bold" },
                            [_vm._v(_vm._s(scope.row.unapproved))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-icon" }, [
      _c("i", { staticClass: "el-icon-picture" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }